import { cn } from '@wellesley/ui'
import W from './W.svg'
import { FC } from 'react'

type WlsyBigLogoProps = { className?: string }
export const WlsyBigLogo: FC<WlsyBigLogoProps> = ({ className }) => (
  <div className={cn('w-[180px]', className)}>
    <img src={W} />
  </div>
)
